// SPDX-License-Identifier: AGPL-3.0-or-later

import {MuteDurationSheet} from '@app/features/app/components/bottomsheets/MuteDurationSheet';
import type {Channel} from '@app/features/channel/models/Channel';
import {useMuteSheet} from '@app/features/notification/hooks/useMuteSheet';
import {useCategoryMenuData} from '@app/features/ui/action_menu/items/CategoryMenuData';
import {MenuBottomSheet} from '@app/features/ui/menu_bottom_sheet/MenuBottomSheet';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';

interface CategoryBottomSheetProps {
	isOpen: boolean;
	onClose: () => void;
	category: Channel;
}
export const CategoryBottomSheet: React.FC<CategoryBottomSheetProps> = observer(({isOpen, onClose, category}) => {
	const {t} = useLingui();
	const additionalMutePayload = useMemo(() => ({collapsed: true}), []);
	const {muteSheetOpen, openMuteSheet, closeMuteSheet, handleMute, handleUnmute, muteConfig} = useMuteSheet({
		guildId: category.guildId ?? null,
		channelId: category.id,
		additionalMutePayload,
	});
	const {groups, state} = useCategoryMenuData(category, {
		onClose,
		onOpenMuteSheet: openMuteSheet,
	});
	return (
		<>
			<MenuBottomSheet isOpen={isOpen} onClose={onClose} groups={groups} title={category.name ?? t`Category Options`} />
			<MuteDurationSheet
				isOpen={muteSheetOpen}
				onClose={closeMuteSheet}
				isMuted={state.isMuted}
				mutedText={state.mutedText}
				muteConfig={muteConfig}
				muteTitle={t`Mute Category`}
				unmuteTitle={t`Unmute Category`}
				onMute={handleMute}
				onUnmute={handleUnmute}
			/>
		</>
	);
});
